import ProfileStore from './ProfileStore';

const sendHostMessage = msg => {
  /* eslint-disable no-console */
  console.info('Sending host message', msg);
  // iOS Message support for wkwebview "accountApp" message handler
  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.accountApp &&
    window.webkit.messageHandlers.accountApp.postMessage
  ) {
    console.info('window.webkit.messageHandlers.accountApp.postMessage', msg);
    window.webkit.messageHandlers.accountApp.postMessage(msg);
  }

  // Android Message support
  if (window.accountApp && window.accountApp.postMessage) {
    console.info('Sending window.accountApp.postMessage', msg);
    window.accountApp.postMessage(msg);
  }

  if (window.opener && window.opener.postMessage) {
    try {
      console.info('Sending window.opener.postMessage', msg);
      window.opener.postMessage(msg, '*');
    } catch (err) {
      console.warn('Failed to post update message');
    }
  }

  /* eslint-enable no-console */
};

class RootStore {
  constructor() {
    this.profileStore = new ProfileStore(this);
    this.checkIfUserComesFromMobile();
  }

  checkIfUserComesFromMobile() {
    const url = new URL(window.location);
    const connectionUrlParam = url.searchParams.get('origin');

    if (connectionUrlParam === 'mobile') {
      sessionStorage.setItem('isNavigatedFromMobile', true);
    }
  }

  sendUpdateNotification() {
    sendHostMessage({
      type: 'FELLER_USER_UPDATE',
      user: this.profileStore.user.sub,
    });
  }

  sendDeleteNotification() {
    sendHostMessage({
      type: 'FELLER_USER_DELETE',
      user: this.profileStore.user.sub,
    });
  }

  sendLogoutNotification() {
    sendHostMessage({
      type: 'FELLER_USER_LOGOUT',
      user: this.profileStore.user.sub,
    });
  }
}

export default new RootStore();
